import type { ReactNode } from "react";

/** A `<details>` whose open state is remembered through `usePrepMemory`. */
export function MemoDetails({
  id,
  summary,
  open,
  onToggle,
  children,
  className,
}: {
  id: string;
  summary: ReactNode;
  open: ReadonlySet<string>;
  onToggle(id: string): void;
  children: ReactNode;
  className?: string;
}) {
  const isOpen = open.has(id);
  return (
    <details
      open={isOpen}
      className={className}
      onToggle={(event) => {
        if (event.currentTarget.open !== isOpen) onToggle(id);
      }}
    >
      <summary className="cursor-pointer font-medium text-ink-900 dark:text-ink-50">
        {summary}
      </summary>
      <div className="mt-2 space-y-3">{children}</div>
    </details>
  );
}
